<template>
  <div>
    <form id="payment-form">
      <v-card-text class="mt-0 pt-0">
        <v-card flat="" outlined="" class="pa-2">
          <div ref="card-element">
            <!-- Elements will create input elements here -->
          </div>
        </v-card>
        <!-- We'll put the error messages in this element -->
        <div class="error--text body-1 mb-0 pb-0" style="height:24px">
          {{ error }}
        </div>
        <!-- <v-alert
          class="mt-1"
          dense
          height=""
          outlined=""
          border="left"
          type="error"
          v-show="error"
        >
          {{ error }}
        </v-alert> -->
      </v-card-text>
    </form>
    <slot
      name="actionslot"
      v-bind:click="onSubmit"
      :loading="loading"
      :finished="finished"
    >
      <v-btn @click="onSubmit">Submit</v-btn>
    </slot>
  </div>
</template>

<script>
import services from "@/services";
export default {
  data: () => ({
    stripeInitializing: true,
    error: "",
    loading: false,
    stripe: null,
    card: null,
    finished: false
  }),
  computed: {
    actions() {
      // eslint-disable-next-line prettier/prettier
      return { click: this.onSubmit, "dad-y": () => {} };
    }
  },
  methods: {
    onSubmit() {
      this.createPaymentMethod(this.card);
    },
    async createPaymentMethod(cardElement, customerId, priceId) {
      try {
        this.loading = true;
        this.error = "";
        const result = await this.stripe.createPaymentMethod({
          type: "card",
          card: cardElement
        });
        if (result.error) {
          this.loading = false;
          console.log(result.error);
          this.error =
            result && result.error && result.error.message
              ? result.error.message
              : "Unknown error occured";
        } else {
          await services.billing.paymentMethods.create({
            paymentmethod: result.paymentMethod.id
          });
          this.$emit("success");
          this.finished = true;
          console.log({
            paymentMethodId: result.paymentMethod.id
          });
        }
      } catch (err) {
        this.error = "Unknown error occured";
        this.loading = true;
      }
    },
    createStripe() {
      // Set your publishable key: remember to change this to your live publishable key in production
      // See your keys here: https://dashboard.stripe.com/account/apikeys
      // eslint-disable-next-line no-undef
      this.stripe = Stripe(process.env.VUE_APP_STRIPE_KEY);
      var elements = this.stripe.elements();
      // Set up Stripe.js and Elements to use in checkout form
      var style = {
        base: {
          color: "#32325d",
          fontFamily: '"Questrial", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      };

      this.card = elements.create("card", { style: style });
      this.card.mount(this.$refs["card-element"]);
      this.card.on("ready", event => {
        this.stripeInitializing = false;
      });
    },
    stripeWrapper() {
      if (window.readyStripe) {
        this.createStripe();
      } else {
        console.log("Retry stripe...");
        setTimeout(() => {
          this.stripeWrapper();
        }, 1000);
      }
    }
  },
  mounted() {
    this.stripeWrapper();
  },
  beforeDestroy() {
    if (this.card) {
      try {
        this.card.destroy();
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style></style>
